import { Flex, FlexProps, Typography } from 'antd';
import React from 'react';
import './style.scss';

interface WidgetCardProps extends FlexProps {
  header?: React.ReactNode;
  renderHeader?: () => React.ReactNode;
  headerExtraContent?: React.ReactNode;
}

const WidgetCard = ({
  header,
  headerExtraContent,
  children,
  renderHeader,
  ...props
}: WidgetCardProps) => {
  const className = `info-card ${props.className ?? ''}`;
  return (
    <Flex {...props} className={className} vertical gap={16}>
      <Flex justify="space-between" align="center" gap={16} wrap="wrap">
        {renderHeader ? (
          renderHeader()
        ) : (
          <Typography.Title level={4}>{header}</Typography.Title>
        )}
        {headerExtraContent}
      </Flex>
      {children}
    </Flex>
  );
};

export default WidgetCard;
